import React from "react";
import {
    Accordion,
    Paper,
    SimpleGrid,
    Stack,
    Text,
    ThemeIcon,
} from "@mantine/core";
import { IconGlassFull } from "@tabler/icons-react";
import type { DrinkBarStatusDto, Language } from "../types";
import type { Texts } from "../texts";
import { getBarName } from "../helpers";

type Props = {
    drinkBars: DrinkBarStatusDto[];
    language: Language;
    onSelectBar: (bar: number) => void;
    t: Texts;
};

export default function DrinksSection({
    drinkBars,
    language,
    onSelectBar,
    t,
}: Props) {
    if (drinkBars.length === 0) return null;

    return (
        <Accordion.Item value="drinks">
            <Accordion.Control
                icon={
                    <ThemeIcon color="red" variant="light" radius="xl">
                        <IconGlassFull size={18} />
                    </ThemeIcon>
                }
            >
                {t.drinks}
            </Accordion.Control>

            <Accordion.Panel>
                <Stack gap="sm">
                    <Text fw={600}>{t.myBars}</Text>

                    <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }}>
                        {drinkBars.map((bar) => (
                            <Paper
                                key={bar.bar}
                                withBorder
                                radius="xl"
                                p="lg"
                                onClick={() => onSelectBar(bar.bar)}
                                style={{
                                    borderColor: "#fa5252",
                                    borderWidth: 2,
                                    cursor: "pointer",
                                    transition: "transform 0.15s ease, box-shadow 0.15s ease",
                                }}
                            >
                                <Stack gap={8}>
                                    <Text fw={700} size="lg">
                                        {getBarName(bar.bar, language)}
                                    </Text>

                                    <Text size="md">
                                        {t.drinksRemaining.replace(
                                            "{count}",
                                            String(bar.remainingDrinks)
                                        )}
                                    </Text>
                                </Stack>
                            </Paper>
                        ))}
                    </SimpleGrid>
                </Stack>
            </Accordion.Panel>
        </Accordion.Item>
    );
}